import { render, staticRenderFns } from "./BannerLite.vue?vue&type=template&id=172f42e9&scoped=true"
import script from "./BannerLite.vue?vue&type=script&lang=js"
export * from "./BannerLite.vue?vue&type=script&lang=js"
import style0 from "./BannerLite.vue?vue&type=style&index=0&id=172f42e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172f42e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VIcon,VImg})
